import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import Sidebar from "./Sidebar"

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
function ContentWrapper({ type, children }) {
    const {
        response,
        foundProducts,
        loading
    } = useAppStateSelector(state => ({ 
        response: state.response,
        foundProducts: state.response.products?.total > 0, 
        loading: state.loading }))

    const productsToShow = response.products?.hits.filter(hit => hit.availability === "InStock" || hit.name.includes("Gift Card") );
    if(window.location.href.includes("/search")) {
        document.title = `Search: ${productsToShow.length} results found for "${response.query}" | böhme`
    }
    return (
        <>
        {window.location.href.includes("/search") &&
        <section class="page-width page-padding padding-inside">
            <div class="sf-wrapper">
                <h1 class="collection-hero__title">Search results for "{response.query}" ({productsToShow.length})</h1>
            </div>    
            <hr style="margin: 0; margin-bottom: 10px;" />
        </section> }
        <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit page-width ns-mx-auto page-padding"
            data-nosto-element={type}>
            {foundProducts && <Sidebar />}
            <div
                class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0"
                style={{ position: loading ? "relative" : "initial" }}>
                { children({ loading, foundProducts }) }
            </div>
        </div>
        </>
    )
}

export function wrapContent(type, Component) {
    return () => (<ContentWrapper type={type}>{Component}</ContentWrapper>)
}

